import React from 'react';
import { ShimmerEffect } from 'V2/Shared/ShimmerEffect';
import styles from './styles.module.css';

interface SkeletonProps {
  width?: string;
  height?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '12px',
}) => (
  <ShimmerEffect className={styles.wrapper}>
    <div className={styles.bone} style={{ width, height }} />
  </ShimmerEffect>
);
